export const PROGRAM_TRAINING_LESSON_TYPE = 'trainingProgram'
export const SCHOOLWIDE_TRAINING_LESSON_TYPE = 'schoolwideTraining'
export const CURRICULUM_TRAINING_LESSON_TYPE = 'trainingCurriculum'
export const MARK_COMPLETE_ID = 'mark-complete'
export const MARK_COMPLETE_HASH = `#${MARK_COMPLETE_ID}`
export const MAX_SCHOOL_NAME_LENGTH = 30
export const COURSE_NODE_ID_KEY = 'courseNodeId'
